// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"146":"084c5ccd","248":"ca3362b4"}[chunkId] + ".chunk.css";
};